import type { IController, material } from 'angular';
import type { PrintingService } from '../../Print/printing.service';
import type { ExportConfig } from '../../Print/export-dialog/export-dialog.component';
import type { I18n } from '../../i18n/mx-internationalization';
import type { Dashboard } from '../dashboard.service';

export class DashboardPrintWizardController implements IController {
	title = '';
	config?: ExportConfig;
	printing = false;
	dashboard!: Dashboard;

	static readonly $inject = ['$mdDialog', 'mx.sb.Printing.PrintingService', 'mx.internationalization'];
	constructor(
		private readonly $mdDialog: material.IDialogService,
		private readonly printingService: PrintingService,
		private readonly i18n: I18n
	) {}

	$onInit() {
		this.title = this.i18n.getFormatted('shell.dashboards.printDashboard', this.dashboard.title);
	}

	handleConfigChange(config: ExportConfig) {
		this.config = config;
	}

	async confirm() {
		if (!this.config) {
			return;
		}
		this.printing = true;
		await this.printingService.printNode(this.config);

		this.printing = false;
		this.$mdDialog.hide();
	}

	cancel() {
		this.$mdDialog.cancel();
	}
}
